import { EnhancedAccount } from "library/accounts/types";
import { ActionMap } from "library/ActionMap";
import { OtpRequiredErrorType } from "library/api/otp/otp";
import { FullPersonalDetails } from "../types";

export enum Page {
  INITIAL = "INITIAL",
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
  VERIFY_EMAIL = "VERIFY_EMAIL",
  OTP_REQUIRED = "OTP_REQUIRED",
}

export type State =
  | { status: Page.INITIAL | Page.ERROR }
  | { status: Page.SUCCESS; email: string }
  | { status: Page.VERIFY_EMAIL; verifyUrl: string }
  | {
      status: Page.OTP_REQUIRED;
      email: string;
      createSessionUrl: string;
      token: string;
    };

export type LocationState = {
  account: EnhancedAccount;
  personalDetails: FullPersonalDetails;
};

export enum ActionTypes {
  BACK = "BACK",
  OTP_NEEDED = "OTP_NEEDED",
  OTP_SUCCESS = "OTP_SUCCESS",
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
  VERIFY = "VERIFY",
}

export type Payloads = {
  [ActionTypes.OTP_NEEDED]: {
    email: string;
    createSessionUrl: string;
    token: string;
  };
  [ActionTypes.VERIFY]: {
    verifyUrl: string;
  };
  [ActionTypes.SUCCESS]: {
    email: string;
  };
};

export type Actions = ActionMap<ActionTypes, Payloads>;

export type UpdateEmailFormValues = {
  email: string;
  confirmEmail: string;
};

export type OTPError =
  | {
      type: "BAD_REQUEST";
      title: "OTP_Exceeded_Allowed_Limits" | "OTP_Mismatch";
    }
  | OtpRequiredErrorType;
